import React from "react";

const CrossSVG = () => {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.66683 1.2735L8.72683 0.333496L5.00016 4.06016L1.2735 0.333496L0.333496 1.2735L4.06016 5.00016L0.333496 8.72683L1.2735 9.66683L5.00016 5.94016L8.72683 9.66683L9.66683 8.72683L5.94016 5.00016L9.66683 1.2735Z" fill="black"/>
        </svg>
    );
};

export default CrossSVG;
